// ESM-Huelle fuer lib/scripts/components/CMP_CContainerRow.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CContainerRow (id)
{
    this.construct (id);

    this.name = "CContainerRow";
    this.htmlType = "tr";
    
    this.columns = new Array ();
    this.name = "CContainerRow";
    this.properties =
    {
        columns: 1,
        styles: {}
    }
}

CContainerRow.prototype = new CComponent;

CContainerRow.prototype.prepare = function ()
{
    for (var c = 0; c < this.properties.columns; c++)
        this.columns[c] = this.addChild (CContainerColumn);

    this.prepared = true;
}
export { CContainerRow };
